module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAlklEQVQoU72QMQrCUBBE33gF7+IhrARbG7GwUMTO0pR2FnoHrZRg5U08Rm4wsuCHYBL8aRxY2GIeM7uyvQcKekh/hWbAokc7FGbbA2AY6w84/FWCDsAuM+2SoBOwzoTKb+j5SYy6dUXtDTAHGlApadKWaDu1aUA3SdMO6Ahs25JewLXjtjEwqkNnYJX5iEd6xBKIydH9DV12SO1S1vUeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/goodsNum.png
// module id = 0lv3
// module chunks = 2